import { render, staticRenderFns } from "./FaqOverlay.vue?vue&type=template&id=ac6fe814&scoped=true"
import script from "./FaqOverlay.vue?vue&type=script&lang=js"
export * from "./FaqOverlay.vue?vue&type=script&lang=js"
import style0 from "./FaqOverlay.vue?vue&type=style&index=0&id=ac6fe814&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac6fe814",
  null
  
)

export default component.exports